import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { CameraServerService } from '../../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConstants, ErrorMessageFormField, FARM_TYPE_LIST } from 'src/app/shared/app-constants';

interface FarmType {
  name: string,
  value: string
}
@Component({
  selector: 'app-move-site',
  templateUrl: './move-site.html',
  styleUrls: ['./move-site.scss'],
  standalone: false
})
export class MoveSite implements OnInit {

  headerName: string = '';
  loading: boolean = false;
  userForm: FormGroup;
  errorMessageFormField: any = ErrorMessageFormField;
  farmTypeData: FarmType[] = FARM_TYPE_LIST;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MoveSite>,
    private camService: CameraServerService,
    private toaster: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      potentialId: ['', [Validators.required]],
      farmType: ['default', [Validators.required]]
    });
    this.headerName = "Move Site to New CS";
  }

  get formControls() {
    return this.userForm.controls;
  }

  moveSite() {
    if (this.userForm.invalid) {
      this.toaster.error('Please enter all required details.');
      return;
    } else if (!this.userForm.value.potentialId || this.userForm.value.potentialId.length !== 6) {
      this.toaster.error('Please enter a valid potential ID.');
      return;
    }
    else {
      this.loading = true;
      this.spinner.activate();
      const payload: any = {
        "platform": "NEW_CAMERA_SERVER",
        "potentials": [this.userForm.value.potentialId],
        "farmType": this.userForm.value.farmType
      }
      this.camService.moveSiteToNewCamServer(payload).subscribe((response: any) => {
        if (response && response.success) {
          this.loading = false;
          this.spinner.deactivate();
          if (this.userForm.value.farmType === 'default') {
            this.toaster.success('The site has been moved successfully.');
          } else {
            if (response?.data?.responseFlag) {
              this.toaster.success((response?.data && response?.data?.status) ? response?.data?.status : 'The site has been moved successfully.');
            } else {
              this.toaster.error((response?.data && response?.data?.status) ? response?.data?.status : '');
            }
          }
        } else {
          this.loading = false;
          this.spinner.deactivate();
          this.toaster.error(AppConstants.defaultErrorMessage);
        }
      },
        (err) => {
          this.loading = false;
          this.spinner.deactivate();
          this.toaster.error(err.message || AppConstants.defaultErrorMessage);
        }
      );
    }
  }

  handleSelectFarmType(event: any) { }
}
